import { render, staticRenderFns } from "./SingleImgUpload.vue?vue&type=template&id=1c054dec&"
import script from "./SingleImgUpload.vue?vue&type=script&lang=js&"
export * from "./SingleImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./SingleImgUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports